/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Legal_Cta_TextInputs */



/**
* | output |
* | --- |
* | "Email us and we will point you to the right person." |
*
* @param {Legal_Cta_TextInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const legal_cta_text = /** @type {((inputs?: Legal_Cta_TextInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Legal_Cta_TextInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("给我们发邮件，我们会为您转给合适的负责人。")
	return /** @type {LocalizedString} */ ("Email us and we will point you to the right person.")
});